// Échec de synchro de la capture d'une prise, vu par l'écran de capture OU par
// le filet global (C20, R77) : même classement (`classifySyncFailure`), même
// inscription au manifeste (`lastError`, domaine `sync`). L'exécuteur relit
// cette inscription à chaque passage et rappelle le signalement « problem » ;
// la notice d'accueil en tire « Problème signalé ».
import type { TakeRecorder } from "../native/take-recorder";
import { classifySyncFailure } from "./sync-capture";
import { syncFailureError } from "./take-lifecycle";
import type { TakeManifest } from "./take-types";

/**
 * Inscrit la classification d'un échec de synchro au manifeste de la prise.
 * Best-effort : rend le manifeste à jour ; si le natif refuse, le manifeste
 * connu (`known`) avec l'erreur, sinon `null`.
 */
export async function recordSyncFailure(
  recorder: Pick<TakeRecorder, "markTake">,
  takeId: string,
  cls: "network" | "problem",
  detail: string,
  known?: TakeManifest,
): Promise<TakeManifest | null> {
  const error = syncFailureError(cls, detail);
  try {
    return await recorder.markTake({ takeId, error });
  } catch {
    return known ? { ...known, lastError: error } : null;
  }
}

/**
 * Échecs de re-synchro du filet qui sont des REFUS (classe « problem ») d'une
 * capture liée à une prise connue. Une panne réseau ou une session expirée
 * n'y figure pas : la relance ou la reconnexion s'en chargent.
 */
export function refusedTakeFailures(
  failures: { id: string; error: string; detail?: string }[],
  takes: TakeManifest[],
  online: boolean,
): { takeId: string; detail: string }[] {
  return failures.flatMap((f) => {
    if (classifySyncFailure(f, online) !== "other") return [];
    const take = takes.find((t) => t.captureId === f.id);
    return take ? [{ takeId: take.takeId, detail: f.detail ?? f.error }] : [];
  });
}
